import { render, staticRenderFns } from "./HeroCategory.vue?vue&type=template&id=3a1c3de8&scoped=true&"
import script from "./HeroCategory.vue?vue&type=script&lang=js&"
export * from "./HeroCategory.vue?vue&type=script&lang=js&"
import style0 from "./HeroCategory.vue?vue&type=style&index=0&id=3a1c3de8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c3de8",
  null
  
)

export default component.exports